import {validateRequired} from './ValidationFunctions';

export const eventCreateConfig = {
  fields: {
    date: {
      type: 'date',
      label: 'Date from',
      placeholder: 'Date from',
      rules: [validateRequired('date from')]
    },
    dateTo: {
      type: 'date',
      label: 'Date to',
      placeholder: 'Date to',
      rules: [validateRequired('date to')]
    },
    start: {
      type: 'time',
      label: 'Starts at',
      placeholder: 'Starts at',
      rules: [validateRequired('starts at')]
    },
    end: {
      type: 'time',
      label: 'Ends at',
      placeholder: 'Ends at',
      rules: [validateRequired('ends at')]
    },
    allDay: {
      type: 'boolean',
      label: 'All Day'
    },
    label: {
      type: 'colorLabels',
      label: 'Label'
    },
    title: {
      type: 'text',
      label: 'Title',

    },
    desc: {
      type: 'text',
      label: 'Description',

    },
    type: {
      type: 'select',
      label: 'Type',
      value: 'value',
      optionLabel: 'label',
      options: [
        {
          value: null,
          label: '(Select type)'
        },
        {
          value: 'on',
          label: 'Days on'
        },
        {
          value: 'off',
          label: 'Days off'
        },
        {
          value: 'court',
          label: 'Court Time'
        },
        {
          value: 'vacation',
          label: 'Vacation Time'
        },
        {
          value: 'shift',
          label: 'Start and End time of shift'
        }
      ],
      rules: []
    }
  }
};
